<template>
  <!--  <div>-->
  <v-container fluid>
    <bread-crumb :breadcrumb-data="breadcrumbData"></bread-crumb>

    <v-row class="mt-4" no-gutters>
      <v-col class="text-left" cols="12">
        <v-btn v-show="!filtersVisible"
               dark elevation="0" small
               style="text-transform: none"
               @click="filtersVisible = true">
          Filter
          <v-icon small>mdi-chevron-double-right</v-icon>
        </v-btn>
      </v-col>

      <v-col :cols="filtersVisible ? 2 : 0">
        <v-slide-y-transition>
          <v-sheet v-if="filtersVisible" class=" pa-4" outlined rounded>
            <v-row>
              <v-col cols="12">
                <v-sheet class="font-weight-bold" style="font-size: 1.1rem;">
                  Filters
                  <v-btn class="float-end"
                         dark elevation="0" small
                         style="text-transform: none"
                         @click="filtersVisible = false">
                    Hide
                    <v-icon small>mdi-chevron-double-left</v-icon>
                  </v-btn>
                </v-sheet>
              </v-col>
              <v-col cols="12">
                <v-expansion-panels v-model="panel" accordion multiple>
                  <!-- Gene 筛选 -->
                  <v-expansion-panel>
                    <v-expansion-panel-header class="font-weight-bold">Gene Level
                      <v-tooltip bottom>
                        <template #activator="{ on, attrs }">
                          <v-icon
                              color="primary"
                              small
                              v-bind="attrs"
                              v-on="on"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>Choose one option from Substrate, NCBI, Uniprot, HGNC or Ensembl </span>
                      </v-tooltip>

                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-combobox
                          v-model="filters.substrate" :disabled="isGeneFilterLocked('substrate')"
                          :items="uniqueValues('substrate')"
                          clearable
                          dense
                          label="Substrate"
                          multiple outlined small-chips
                      ></v-combobox>
                      <v-combobox
                          v-model="filters.genename" :disabled="isGeneFilterLocked('Gene_Name_List')"
                          :items="uniqueValues('Gene_Name_List')"
                          clearable
                          dense
                          label="Gene Name"
                          multiple outlined small-chips
                      ></v-combobox>
                      <v-combobox
                          v-model="filters.NCBI" :disabled="isGeneFilterLocked('ncbi_gene')"
                          :items="uniqueValues('ncbi_gene')"
                          clearable
                          dense
                          label="NCBI"
                          multiple outlined small-chips
                      ></v-combobox>

                      <v-combobox
                          v-model="filters.UniProt" :disabled="isGeneFilterLocked('uniprot_list')"
                          :items="uniqueValues('uniprot_list')"
                          clearable
                          dense
                          label="UniProt"
                          multiple outlined small-chips
                      ></v-combobox>

                      <v-combobox
                          v-model="filters.HGNC" :disabled="isGeneFilterLocked('hgnc_id')"
                          :items="uniqueValues('hgnc_id')"
                          clearable
                          dense
                          label="HGNC"
                          multiple outlined small-chips
                      ></v-combobox>

                      <v-combobox
                          v-model="filters.Ensembl" :disabled="isGeneFilterLocked('Ensembl')"
                          :items="uniqueValues('ensembl_gene')"
                          clearable
                          dense
                          label="Ensembl"
                          multiple outlined small-chips
                      ></v-combobox>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header class="font-weight-bold">Site Level</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-combobox
                          v-model="filters.harm_site_list"
                          :items="uniqueSites"
                          clearable
                          dense label="Site" multiple outlined small-chips
                      ></v-combobox>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
              <v-col cols="12">
                <v-row>
                  <v-spacer></v-spacer>
                  <v-col cols="4">
                    <v-btn color="secondary" small @click="resetFilters">Reset</v-btn>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
          </v-sheet>
        </v-slide-y-transition>
      </v-col>

      <v-col :cols="filtersVisible ? 10 : 12">
        <v-sheet class=" ml-3 transparent">
          <v-row>
            <v-col cols="12">
              <v-sheet rounded>
                <div>
                  <v-icon color="blue" small>mdi-heart</v-icon>
                  Help
                </div>
                <div style="font-size: 0.9rem"> The <a class="font-weight-bold">Substrate, Site</a> can be clicked to
                  the single search page
                </div>
                <div style="font-size: 0.9rem"> The <a class="font-weight-bold">Site</a> can be clicked to the
                  site search site
                </div>
                <div style="font-size: 0.9rem"> The <a class="font-weight-bold">Uniprot, NCBI, HGNC and Ensembl
                  accession
                  ID
<!--                  <v-icon>mdi-share</v-icon>-->
                </a> can be clicked to corresponding outside database
                </div>
              </v-sheet>
            </v-col>
          </v-row>

          <!-- Progress Circular Loading -->
          <v-row v-if="loading" align="center" justify="center">
            <v-progress-circular
                :rotate="360"
                :size="100"
                :value="progressValue"
                :width="15"
                color="teal"
            >
              {{ progressValue }}
            </v-progress-circular>
          </v-row>

          <!-- Statistics and Table -->
          <v-row v-else>
            <v-col cols="12">
              <v-row no-gutters>
                <v-spacer></v-spacer>
                <v-col class="align-content-center" cols="4">
                  <a class="font-weight-bold" style="font-size: 1.2rem; color: red">{{ filteredData.length }} </a>
                  <a class="font-weight-bold" style="font-size: 1rem; color: black">genes are involved</a>
                  <v-btn class="ml-6" color="primary" dense small style="text-transform: none"
                         @click="downloadCSV">
                    Download TSV
                    <v-icon>mdi-download-box-outline</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      class="my-2"
                      clearable
                      dense
                      hide-details
                      label="Search"
                      outlined
                      single-line
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-sheet outlined>
                <v-data-table
                    v-if="filteredData.length > 0"
                    :footer-props="{ 'items-per-page-options': [10, 20, 50, 100],
                          'show-current-page': true}"
                    :headers="headers"
                    :items="filteredData"
                    :items-per-page="10"
                    :search="search"
                    class="sticky-table"
                    dense
                    fixed-header
                    height="550px"
                    no-data-text="No results available. Please initiate a search by selecting 'Search Items' to navigate the database. "
                >
                  <!-- Substrate -->
                  <template #item.substrate="{ item }">
                    <a
                        :href="baseUrl + '/#/single-search?substrate=' + item.substrate"
                        class="font-weight-bold"
                        style="color: black"
                        target="_blank"
                    >
                      {{ item.substrate }}
                    </a>
                  </template>
                  <template #item.harm_site_list="{ item }">
                    <div style="display: flex; flex-wrap: wrap; align-items: center;">
                      <span
                          v-for="(site, index) in getDisplaySites(item)"
                          :key="index"
                          style="margin-right: 6px; margin-bottom: 4px;">
                        <a :href="baseUrl + '/#/single-search?substrate=' + item.substrate + '&site=' + site"
                           target="_blank">
                          <v-chip class="my-1" color="orange" dense outlined small>{{ site }}</v-chip>
                        </a>
                      </span>
                      <v-btn
                          v-if="filteredSiteList(item).length > 8"
                          color="black"
                          outlined
                          rounded
                          text
                          x-small
                          @click="toggleShowAllSites(item)">
                        {{ isSiteExpanded(item) ? "Show Less" : "Show More" }}
                      </v-btn>
                    </div>
                  </template>
                  <!-- Ensembl -->
                  <template #item.ensembl_gene="{ item }">
                    <a
                        v-if="item.ensembl_gene"
                        :href="'https://useast.ensembl.org/homo_sapiens/Gene/Summary?g=' + item.ensembl_gene + '&db=core'"
                        style="text-decoration: none"
                        target="_blank"
                    >
                      {{ item.ensembl_gene }}
<!--                      <v-icon dense small>mdi-share</v-icon>-->
                    </a>
                    <span v-else>-</span>
                  </template>

                  <template #item.ncbi_gene="{ item }">
                    <span v-if="item.ncbi_gene && item.ncbi_gene.toString().trim().toLowerCase() !== 'nan'">
                      <a
                          :href="'https://www.ncbi.nlm.nih.gov/gene/' + parseInt(item.ncbi_gene)"
                          style="text-decoration: none;"
                          target="_blank"
                      >
                        {{ parseInt(item.ncbi_gene) }}
<!--                        <v-icon dense small>mdi-share</v-icon>-->
                      </a>
                    </span>
                    <span v-else>-</span>
                  </template>

                  <template #item.hgnc_id="{ item }">
                    <span v-if="item.hgnc_id && item.hgnc_id.toString().trim().toLowerCase() !== 'non'">
                      <a
                          :href="'https://www.genenames.org/data/gene-symbol-report/#!/hgnc_id/'  + item.hgnc_id"
                          style="text-decoration: none;"
                          target="_blank"
                      >
                        {{ item.hgnc_id }}
<!--                        <v-icon dense small>mdi-share</v-icon>-->
                      </a>
                    </span>
                    <span v-else>-</span>
                  </template>


                  <!-- UniProt -->
                  <template #item.uniprot_list="{ item }">
                          <span v-if="item.uniprot_list">
                            <span v-for="(uniprot, index) in item.uniprot_list.split(',')" :key="index">
                              <a
                                  :href="'https://www.uniprot.org/uniprotkb/' + uniprot.trim() + '/entry'"
                                  style="text-decoration: none; margin-right: 5px;"
                                  target="_blank">
                                {{ uniprot.trim() }}
<!--                                <v-icon dense x-small>mdi-share</v-icon>-->
                              </a>
                              <span v-if="index < item.uniprot_list.split(',').length - 1">, </span>
                            </span>
                          </span>
                    <span v-else>-</span>
                  </template>


                  <!-- gene names -->
                  <template #item.Gene_Name_List="{ item }">
                          <span v-if="item.Gene_Name_List">
                            {{item.Gene_Name_List}}
<!--                            <span-->
<!--                                v-for="(alias, index) in item.Gene_Name_List?.split(',') || []"-->
<!--                                :key="index"-->
<!--                                style="margin-right: 10px">-->
<!--                              <v-chip class="my-1" color="darkgrey" dense outlined small>{{ alias }}</v-chip>-->
<!--                            </span>-->
                          </span>

                    <span v-else>-</span>
                  </template>
                  <template #item.site_num="{ item }">
                    {{ ptmNumber(item) }}
                  </template>
                </v-data-table>

              </v-sheet>
            </v-col>
          </v-row>
        </v-sheet>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BreadCrumb from "@/components/sub/breadcrumb.vue";
import Axios from "axios";
// import BrowseTable from "@/components/BrowseTable.vue";

export default {
  name: "Browse",
  props: [],
  components: {BreadCrumb},
  data() {
    return {
      filtersVisible: true,
      table_res: [],
      loading: true,
      progressValue: 0,
      headers: [
        {text: "Substrate", value: "substrate", width: "6%"},
        {text: "Entry ID", value: "uniprot_list", width: "8%"},
        {text: "NCBI ID", value: "ncbi_gene", width: "6%"},
        {text: "HGNC ID", value: "hgnc_id", width: "8%"},
        {text: "Ensembl Gene", value: "ensembl_gene", width: "12%"},
        {text: "Gene Names", value: "Gene_Name_List", width: "20%"},
        {text: "PTM Type", value: "ptm_type", width: "8%"},
        {text: "#PTM number", value: "site_num", width: "6%"},
        {text: "Site", value: "harm_site_list", width: "26%"},
      ],
      filters: {
        substrate: [],
        genename: [],
        NCBI: [],
        UniProt: [],
        HGNC: [],
        Ensembl: [],
        harm_site_list: [],
        ptm_type: [],
      },
      geneFilterKeys: ['substrate', 'genename', 'NCBI', 'UniProt', 'HGNC', 'Ensembl'],
      resetfilter: {
        substrate: [],
        genename: [],
        NCBI: [],
        UniProt: [],
        HGNC: [],
        Ensembl: [],
        harm_site_list: [],
        ptm_type: [],
      },
      expandedSites: {},
      panel: [0],
      search: ''
    }
  },
  methods: {
    resetFilters() {
      this.filters = JSON.parse(JSON.stringify(this.resetfilter)); // 深拷贝，避免引用
    },

    sortedSites(sites) {
      // 使用正则表达式提取数字部分并排序
      return sites
          .map((site) => ({
            original: site,
            number: parseInt(site.match(/\d+/)?.[0] || "0", 10), // 提取数字部分，若无数字则为 0
          }))
          .sort((a, b) => a.number - b.number) // 按数字部分排序
          .map((sorted) => sorted.original); // 返回排序后的原始值
    },
    browse_table() {
      this.loading = true;
      this.progressValue = 0; // Reset progress value

      const interval = setInterval(() => {
        if (this.progressValue < 90) {
          this.progressValue += 10; // Increment progress
        }
      }, 200);

      Axios.post(`${apiprefix}/api/browse_table/`, {}, {})
          .then((res) => {
            if (res.status) {
              this.table_res = res.data.data.map(item => {
                return {
                  ...item,
                  ncbi_gene: item.ncbi_gene ? parseInt(item.ncbi_gene) : null,
                  Gene_Name_List: item.Gene_Name_List || '',
                  uniprot_list: item.uniprot_list || '',
                  harm_site_list: item.harm_site_list || '',
                };
              });
              this.$nextTick(() => {
                // 在数据加载完成后强制等待 DOM 渲染
                this.adjustLayout();
              });
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          })
          .finally(() => {
            clearInterval(interval); // Clear progress interval
            this.progressValue = 100; // Set progress to 100% upon completion
            this.loading = false;
          });
    },

    adjustLayout() {
    },
    toggleShowAllSites(item) {
      // 切换当前 item 的 site 展开/折叠状态
      const key = item.substrate;
      if (this.expandedSites[key]) {
        this.$set(this.expandedSites, key, false);
      } else {
        this.$set(this.expandedSites, key, true);
      }
    },
    isSiteExpanded(item) {
      // 检查当前 item 是否是展开状态
      return !!this.expandedSites[item.substrate];
    },
    getDisplaySites(item) {
      const sorted = this.sortedSites(this.filteredSiteList(item));
      return this.isSiteExpanded(item) ? sorted : sorted.slice(0, 8);
    },

    uniqueValues(field) {
      const values = this.table_res
          .map(item => item[field])
          .filter(v => v !== null && v !== undefined)
          .flatMap(val => {
            if (typeof val === 'string') {
              return val.split(',').map(s => s.trim());
            } else {
              return [String(val)];
            }
          });

      return [...new Set(values)];
    },

    isGeneFilterLocked(activeKey) {
      return this.geneFilterKeys.some(key => key !== activeKey && this.filters[key].length > 0);
    },
    // site 选择后清洗数据，保持只有选中 site 出现在列表中
    filteredSiteList(item) {
      const allSites = item.harm_site_list?.split(',').map(s => s.trim()) || [];
      if (!this.filters.harm_site_list.length) return allSites;
      return allSites.filter(s => this.filters.harm_site_list.includes(s));
    },
    // 计算每个条目的 PTM 数（根据 site 数）
    ptmNumber(item) {
      return this.filteredSiteList(item).length;
    },
    downloadCSV() {
      const csvContent = this.convertToCSV(this.filteredData);
      const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'});
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', 'ptmatlas_substrate_centric_table.tsv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // Method to convert data to CSV format
    convertToCSV(data) {
      const headers = this.headers.map(header => header.text).join('\t') + '\n';

      const rows = data.map(item => {
        return this.headers.map(header => {
          if (header.value === 'site_num') {
            return this.ptmNumber(item); // 重新计算 PTM 数
          } else if (header.value === 'harm_site_list') {
            return this.filteredSiteList(item).join(','); // 用筛选后的 site 列表
          } else {
            return item[header.value];
          }
        }).join('\t');
      }).join('\n');

      return headers + rows;
    }

  },
  created() {
    this.browse_table();
    this.$nextTick(() => {
    });

  },
  computed: {
    breadcrumbData() {
      return [
        {text: "Home", disabled: false, to: "/"},
        {text: "Browse", disabled: true}
      ];
    },
    baseUrl() {
      return window.location.origin;
    },
    numberRange() {
      const numbers = this.table_res.map((item) => item.number);
      return {min: Math.min(...numbers), max: Math.max(...numbers)};
    },
    filteredData() {
      return this.table_res.filter(item => {
        const ncbiGene = item.ncbi_gene ? parseInt(item.ncbi_gene) : null;
        const substrateMatch = !this.filters.substrate.length || this.filters.substrate.includes(item.substrate);

        const ncbiMatch =
            !this.filters.NCBI.length ||
            this.filters.NCBI.some(v => parseInt(v) === ncbiGene);

        const hgncMatch = !this.filters.HGNC.length || this.filters.HGNC.includes(item.hgnc_id);
        const ensemblMatch = !this.filters.Ensembl.length || this.filters.Ensembl.includes(item.ensembl_gene);
        const geneList = item.Gene_Name_List.split(',').map(s => s.trim());
        const genenameMatch = !this.filters.genename.length ||
            this.filters.genename.some(name => geneList.includes(name));

        const uniList = item.uniprot_list.split(',').map(s => s.trim());
        const uniProtMatch = !this.filters.UniProt.length ||
            this.filters.UniProt.some(u => uniList.includes(u));


        const siteMatch = !this.filters.harm_site_list.length ||
            this.filters.harm_site_list.some(site =>
                item.harm_site_list?.split(',').map(s => s.trim()).includes(site)
            );

        return substrateMatch && genenameMatch && ncbiMatch && uniProtMatch && hgncMatch && ensemblMatch && siteMatch;
      });
    },
    // 用于 Site 下拉列表的动态更新（选了 gene 时仅显示该 gene 的 site）
    uniqueSites() {
      const siteSet = new Set();
      this.filteredData.forEach(item => {
        if (item.harm_site_list) {
          item.harm_site_list.split(',').forEach(site => siteSet.add(site.trim()));
        }
      });
      return [...siteSet];
    },
  }
}
</script>

<style lang="scss" scoped type="text/scss">
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: black !important;
  font-size: 0.9rem;
  white-space: nowrap
}

.sticky-table td:first-child {
  position: sticky;
  left: 0;
  background: white;
  z-index: 10;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
}

</style>

